import React from "react";
import { STATUS_LABEL } from "../lib/api";

export default function StatusBadge({ status, className = "", testId }) {
  const label = STATUS_LABEL[status] || status;
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold status-${status} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}
